export default __webpack_public_path__ + "static/media/back_connect.d80eee47.svg";